import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable no-mixed-spaces-and-tabs */
import object from '../../../common/object'; // msg=2|32702 615628028 2 4|
// let query_role_result={retCode:0,data:'_tail_request_body_=cmd|1002||uin|615628031||area|1&area=1&
// msg=3|1037060 615628031 0 1|15697775 %E5%93%88%E5%93%88%E5%93%88%E5%93%88ddv 0 1|15697785 %E5%93%88%E5%93%88%E5%93%88%E5%93%88%E5%93%88dv 0 1|&result=0&uin=615628031&',msg:'ok',checkparam:'dnf|yes|615628031|1|1037060*15697775*15697785*',md5str:'1A12D5096D8DB8F483E170D80716A62C'};

export default function (queryRoleResult, request) {
  var checkparam = queryRoleResult.checkparam,
      md5str = queryRoleResult.md5str;
  queryRoleResult.data = encodeURI(queryRoleResult.data);
  var map = object.unSerialize(queryRoleResult.data);

  if (map.result) {
    if (map.result * 1 != 0) {
      return {
        iRet: 2,
        // 未查询到角色信息
        sMsg: '查询人数过多，请您稍后再来！',
        arrRole: null
      };
    }
  }

  var _arrRole = map.msg;

  if (!_arrRole) {
    return {
      iRet: 3,
      // 未查询到角色信息
      sMsg: '在该服务器上未获取到角色信息！',
      arrRole: null
    };
  }

  _arrRole = _arrRole.split('|').filter(function (item) {
    return item;
  });

  if (_arrRole.length == 1) {
    return {
      iRet: 3,
      // 未查询到角色信息
      sMsg: '在该服务器上未获取到角色信息！',
      arrRole: null
    };
  }

  var _arrRoleList = [];

  for (var i = 1; i < _arrRole.length; i++) {
    if (_arrRole[i]) {
      var _oneArray = _arrRole[i].split(' ');

      if (_oneArray.length >= 4) {
        try {
          _oneArray[1] = decodeURIComponent(_oneArray[1]);
        } catch (e) {//
        }

        var _tempobj = _objectSpread(_objectSpread({
          roleId: _oneArray[0],
          roleName: _oneArray[1],
          roleJob: _oneArray[2],
          roleLevel: _oneArray[3]
        }, request), {}, {
          checkparam: checkparam,
          md5str: md5str
        });

        _arrRoleList.push(_tempobj);
      }
    }
  }

  return {
    iRet: 0,
    // 查询到角色信息
    sMsg: 'OK',
    arrRole: _arrRoleList
  };
}